import { render, staticRenderFns } from "./piweb-topo.vue?vue&type=template&id=8672bcc4&scoped=true&"
import script from "./piweb-topo.vue?vue&type=script&lang=js&"
export * from "./piweb-topo.vue?vue&type=script&lang=js&"
import style0 from "./piweb-topo.vue?vue&type=style&index=0&id=8672bcc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8672bcc4",
  null
  
)

export default component.exports